<div fxLayout="column" class="layout-padd" fxLayoutAlign="center center" [ngStyle]="{'max-height.px': innerHeight}" fxFlexFill>

    <div class="layout-padd text-center">
        <span class="mat-subheading-1">{{'alertinvalidpriceComponent.noproduct'|translate}}</span>
    </div>

    <div class="layout-padd full-w">

        <mat-list>

            <mat-list-item *ngFor="let prod of unavailableProds; let last = last;">
                <img matListAvatar [src]="prod.image[0] ? prod.image[0] : '/assets/img/not-found.png'">
                <div matLine>
                    <!-- <span>{{prod.name}}</span> -->
                    <span>{{prod.display_lang.name}}</span>

                    <div fxFlex></div>
                    <span class="mat-caption boldest warn-ico">{{'alertinvalidpriceComponent.undis'|translate}}  </span>
                </div>
                <mat-divider *ngIf="!last"></mat-divider>
            </mat-list-item>

            <mat-divider *ngIf="changedPriceProds.length >0"></mat-divider>

            <mat-list-item *ngFor="let prod of changedPriceProds; let last = last;">
                <img matListAvatar [src]="prod.image[0] ? prod.image[0] : '/assets/img/not-found.png'">
                <div matLine >
                    <!-- <span>{{prod.name}}</span> -->
                    <span style="padding-left: 5px;"> {{prod.display_lang.name}}</span>

                    <div fxFlex></div>

                    <span *ngIf="prod.price_difference < 0 && !merchantClient" class="mat-caption boldest great-ico">{{prod.price_difference| priceFilter}}</span>
                    <span *ngIf="prod.price_difference > 0  && !merchantClient" class="mat-caption boldest warn-ico">+{{prod.price_difference | priceFilter}}</span>

                    <span *ngIf="prod.price_difference < 0  && merchantClient" class="mat-caption boldest great-ico">{{prod.price_difference|discountVipFilter:merchantClient:prod| priceFilter}}</span>
                    <span *ngIf="prod.price_difference > 0  && merchantClient" class="mat-caption boldest warn-ico">+{{prod.price_difference|discountVipFilter:merchantClient:prod | priceFilter}}</span>
                </div>
                <mat-divider *ngIf="!last"></mat-divider>
            </mat-list-item>

        </mat-list>

    </div>

    <div fxLayout="column" fxLayoutGap="10px" class="layout-padd full-w">

        <button *ngIf="tools.checkCurrentPage('product')" mat-raised-button class="primary" (click)="closeDial(true)" angulartics2On="click" angularticsAction="continueInvalidPricePeriodDial" angularticsCategory="productsTimeSlot" fxFlex>
      <span class="mat-title">{{"dialogs.continue" | translate}} </span>
    </button>

        <button mat-stroked-button class="dark-ico" (click)="closeDial()" angulartics2On="click" angularticsAction="closeInvalidPricePeriodDial" angularticsCategory="productsTimeSlot" fxFlex>
      <span class="mat-title">{{"dialogs.go-back" | translate}} </span>
    </button>

    </div>

</div>
